import { SamplePack } from '@arpeggi/shared'
import { Image } from '@arpeggi/ui'
import { FC } from 'react'
import ProfileCard from '../../../__legacy__/components/platform/dashboard/ProfileCard'
import { useColorThief } from '../hooks'
import { Main, PlayerWrapper, TopNav } from '../primitives'
import { SPContributorsSection } from './SPContributorsSection'
import { SPInfo } from './SPInfo'
import { SPRecentActivity } from './SPRecentActivity'

export const SPMainSection: FC<{ samplePack: SamplePack }> = ({ samplePack }) => {
  const { coverImage, title } = samplePack
  const { gradient } = useColorThief(coverImage.url)

  return (
    <Main.Root css={{ background: gradient }}>
      <Main.Flare />
      <TopNav.Root>
        <TopNav.BackButton />
        <ProfileCard />
      </TopNav.Root>
      <Main.Content>
        <Main.PlayerArea>
          <PlayerWrapper.Root>
            <PlayerWrapper.Content>
              <Image src={coverImage.url} css={{ width: '100%', height: '100%' }} />
            </PlayerWrapper.Content>
          </PlayerWrapper.Root>
        </Main.PlayerArea>
        <Main.InfoArea>
          <SPInfo sp={samplePack} />
          <SPContributorsSection sp={samplePack} />
          <SPRecentActivity sp={samplePack} />
        </Main.InfoArea>
      </Main.Content>
    </Main.Root>
  )
}
